export default [
  {
    path: '/about',
    component: () => import('@/views/pages/about/index.vue'),
    redirect: '/about/aboutus',
    children: [
      {
        path: 'aboutus',
        name: 'aboutus',
        meta: { title: "关于我们" },
        component: () => import('@/views/pages/about/aboutus.vue')
      },
      {
        path: 'service',
        name: 'service',
        meta: { title: "使用协议" },
        component: () => import('@/views/pages/about/service.vue')
      },
      {
        path: 'content',
        name: 'content',
        meta: { title: "内容规范" },
        component: () => import('@/views/pages/about/content.vue')
      },
      {
        path: 'privacy',
        name: 'privacy',
        meta: { title: "隐私政策" },
        component: () => import('@/views/pages/about/privacy.vue')
      },
      {
        path: 'help',
        name: 'help',
        meta: { title: "常见问题" },
        component: () => import('@/views/pages/about/help.vue')
      },
      {
        path: 'contactus',
        name: 'contactus',
        meta: { title: "联系方式" },
        component: () => import('@/views/pages/about/contactus.vue')
      },
      {
        path: 'opinionaire',
        name: 'opinionaire',
        meta: { title: "意见反馈" },
        component: () => import('@/views/pages/about/opinionaire.vue')
      },
      {
        path: 'join',
        name: 'join',
        meta: { title: "加入我们" },
        component: () => import('@/views/pages/about/join.vue')
      }
    ]
  }
]